module.exports = __webpack_public_path__ + "media/images/how-img-1920-1add8e30f49b7268548f87b13d28384f.svg";